@if (isRegimenExpired && !loading && !acquisitionUI) {
  <div class="tw-w-full tw-h-11 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-bg-white">
    <div class="tw-absolute tw-left-6 tw-top-3 tw-flex tw-items-center tw-justify-center tw-rounded-xl" (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]="'arrow_back'"></cs-icon>
    </div>
    <span class="tw-font-body tw-font-bold tw-text-300 tw-text-black">Doctor Check-ups</span>
  </div>
} @else if (!loading) {
  <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
  </div>
}
@if (loading) {
  <loading class="pos-abs vh-center"></loading>
}
<!--new checkup UI-->
@if (!loading) {
  @if (acquisitionUI) {
    <!-- Acquisition UI - new design placeholder -->
    <ng-container>
      <section class="tw-bg-teal-200 tw-pb-6" [ngClass]="isRegimenExpired ? 'tw-pt-6' : 'tw-pt-20'">
        <h1 class="tw-font-body tw-font-bold tw-text-700 tw-px-6 tw-pt-2 tw-pb-1" i18n="@@myDoctorCheckups">
          My doctor checkups
        </h1>
        <p class="tw-text-teal-700 tw-leading-4 tw-mb-4 tw-px-6 tw-font-body">
          @if (isSkinSpecialist && isHairSpecialist) {
            <span i18n="@@skinAndHair" class="tw-text-300 tw-font-medium">Skin and Hair</span>
          }
          @if (isSkinSpecialist && !isHairSpecialist) {
            <span i18n="@@skin" class="tw-text-300 tw-font-medium">Skin</span>
          }
          @if (isHairSpecialist && !isSkinSpecialist) {
            <span i18n="@@hair" class="tw-text-300 tw-font-medium">Hair</span>
          }
          <span>&nbsp;</span>
          <span i18n="@@specialist">Specialist</span>
          <span>:</span>
          <span class="tw-font-bold"> {{doctorName}} </span>
        </p>
        <swiper id="followUp-swiper-2" class="tw-max-w-full tw-overflow-visible tw-px-4 tw-z-0 tw-font-body tw-text-300" [config]="followUpCarouselConfig">
          <!--  Lock Card Acquisition-->
          @for (index of [1, 2, 3]; track index) {
            @if (index === 1) {
              <div *swiperSlide class="tw-h-full">
                <div class="tw-w-32 tw-bg-white tw-rounded-4 tw-shadow-z5 tw-h-full">
                  <div class="tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-3 tw-pb-[11px] tw-pt-[19px]">
                    <h3 class="tw-text-gray-800 tw-font-bold tw-mb-4">
                      <span>1</span>
                      <span class="tw-align-super tw-text-100 tw-mr-0.5">{{ 1 | dateSuffix: true }}</span>
                      <span>&nbsp;</span>
                      <span i18n="@@checkup" class="tw-capitalize">Check-up</span>
                    </h3>
                    <img alt="checkup-lock-icon" src="/assets/icons/checkup-lock-icon.svg" class="tw-w-9 tw-mb-4">
                    <p class="tw-text-teal-600 tw-font-[700] tw-pb-2" i18n="@@after2Weeks">After 2 weeks</p>
                  </div>
                </div>
              </div>
            } @else {
              <div *swiperSlide class="tw-h-full">
                <div class="tw-w-32 tw-bg-teal-100 tw-rounded-4 tw-shadow-z5 tw-h-full">
                  <div class="tw-h-full tw-flex tw-flex-col tw-gap-3 tw-justify-center tw-items-center tw-px-3 tw-py-5">
                    <h3 i18n="@@nextCheckup" class="tw-text-gray-500 tw-text-center">Next Checkup</h3>
                    <img alt="checkup-lock-icon" src="/assets/icons/checkup-lock-icon.svg" class="tw-w-9 tw-mt-1">
                    <span class="tw-text-teal-600 tw-font-bold tw-invisible tw-mt-5"></span>
                  </div>
                </div>
              </div>
            }
          }
        </swiper>
      </section>
      <div>
        <img [src]="acqCheckupContentImage" alt="checkup" class="tw-w-full" />
      </div>
    </ng-container>
  } @else {
    @if (isRegimenExpired) {
      <regimen-expired-strip></regimen-expired-strip>
    }
    <section class="tw-bg-teal-200 tw-pb-6" [ngClass]="isRegimenExpired ? 'tw-pt-6' : 'tw-pt-20'">
      @if (isRegimenExpired) {
        <h1 class="tw-font-body tw-font-bold tw-text-400 tw-px-4 tw-pb-4">Past Check-ups</h1>
      } @else {
        <h1 i18n="@@myCheckups" class="tw-font-body tw-font-bold tw-text-700 tw-px-6 tw-pt-2 tw-pb-1">
        My Check-ups
      </h1>
      }
      @if (!isRegimenExpired) {
        <p class="tw-text-teal-700 tw-leading-4 tw-mb-4 tw-px-6 tw-font-body">
          @if (isSkinSpecialist && isHairSpecialist) {
            <span i18n="@@skinAndHair" class="tw-text-300 tw-font-medium">Skin and Hair</span>
          }
          @if (isSkinSpecialist && !isHairSpecialist) {
            <span i18n="@@skin" class="tw-text-300 tw-font-medium">Skin</span>
          }
          @if (isHairSpecialist && !isSkinSpecialist) {
            <span i18n="@@hair" class="tw-text-300 tw-font-medium">Hair</span>
          }
          <span>&nbsp;</span>
          <span i18n="@@specialist">Specialist</span>
          <span>:</span>
          <span class="tw-font-bold"> {{doctorName}} </span>
        </p>
      }
      <swiper id="followUp-swiper" class="tw-max-w-full tw-overflow-visible tw-px-4 tw-z-0 tw-font-body tw-text-300" [config]="followUpCarouselConfig">
        @for (followUp of extendedUserAllFollowUps; track followUp; let i = $index) {
          <!--  notify me card-->
          @if (showNotifyMeCard(followUp)) {
            <div *swiperSlide class="tw-h-full">
              <div class="tw-w-32 tw-bg-gray-50 tw-rounded-4 tw-shadow-z5 tw-h-full">
                <div class="tw-h-full tw-flex tw-flex-col tw-gap-3 tw-items-center tw-px-3 tw-py-5">
                  <h3 class="tw-text-gray-800 tw-font-bold">
                    <span>{{i + 1}}</span>
                    <span class="tw-align-super tw-text-100 tw-mr-0.5">{{ (i + 1).toString() | dateSuffix: true }}</span>
                    <span>&nbsp;</span>
                    <span i18n="@@checkup" class="tw-capitalize">Check-up</span>
                  </h3>
                  <h1 class="tw-text-center tw-tracking-wider tw-leading-none">
                    <span class="tw-leading-none tw-uppercase tw-text-300 tw-block">
                      {{followUp.nextFollowUpDate['iso'] | date: 'MMM'}}
                    </span>
                    <span class="tw-text-900 tw-font-bold tw-leading-none tw-block">
                      {{followUp.nextFollowUpDate['iso'] | date: 'dd'}}
                    </span>
                  </h1>
                  <span i18n="@@notifyMe" class="tw-text-teal-600 tw-font-bold tw-text-center tw-mt-auto" (click)="toggleNotifyMePopup()">Notify me</span>
                </div>
              </div>
            </div>
          } @else {
            @if (showFollowUpActiveCard(followUp)) {
              <div *swiperSlide class="tw-h-full">
                <div class="tw-w-32 tw-bg-gray-50 tw-rounded-4 tw-relative tw-shadow-z5 tw-h-full">
                  <img src="/assets/gifs/blinking-red-dot.gif" class="tw-absolute -tw-top-0.5 tw-right-2 tw-w-[10px]" alt="red-blink-circle"/>
                  <div class="tw-h-full tw-flex tw-flex-col tw-gap-3 tw-items-center tw-px-3 tw-py-5">
                    <h3 class="tw-text-gray-800 tw-font-bold">
                      <span>{{i + 1}}</span>
                      <span class="tw-align-super tw-text-100 tw-mr-0.5">{{ (i + 1).toString() | dateSuffix: true }}</span>
                      <span i18n="@@checkup" class="tw-capitalize">Check-up</span>
                    </h3>
                    <img alt="doctor profile" src="{{doctorImage}}" class="tw-aspect-square tw-w-14 tw-bg-gray-200 tw-rounded-full">
                    <span i18n="@@takeNow" class="tw-text-white tw-bg-teal-600 tw-font-bold tw-text-center tw-px-4 tw-py-1.5 tw-rounded-lg tw-mt-auto tw-break-normal" (click)="startFollowUpOfId(followUp)">Start now</span>
                  </div>
                </div>
              </div>
            } @else {
              @if (showReportInProcessCard(followUp)) {
                <div *swiperSlide class="tw-h-full">
                  <div class="tw-w-32 tw-bg-gray-50 tw-rounded-4 tw-shadow-z5 tw-h-full">
                    <div class="tw-h-full tw-flex tw-flex-col tw-gap-3 tw-items-center tw-px-3 tw-py-5">
                      <h3 class="tw-text-gray-800 tw-font-bold">
                        <span>{{i + 1}}</span>
                        <span class="tw-align-super tw-text-100 tw-mr-0.5">{{ (i + 1).toString() | dateSuffix: true }}</span>
                        <span i18n="@@checkup" class="tw-capitalize">Check-up</span>
                      </h3>
                      <img alt="sand-watch-loader" src="/assets/images/sand-watch-loader.gif" class="tw-aspect-square tw-w-14 tw-bg-gray-200 tw-rounded-full tw-object-cover">
                      <span i18n="@@inProcess" class="tw-text-teal-600 tw-font-bold tw-capitalize tw-text-center tw-mt-auto" (click)="toggleProcessPopup()">In process</span>
                    </div>
                  </div>
                </div>
              } @else {
                @if (showFollowUpWaitingForImageCard(followUp)) {
                  <div *swiperSlide class="tw-h-full">
                    <div class="tw-w-32 tw-bg-gray-50 tw-rounded-4 tw-relative tw-shadow-z5 tw-h-full tw-min-h-40">
                      <div class="tw-h-full tw-flex tw-flex-col tw-gap-3 tw-items-center tw-px-3 tw-py-5">
                        <h3 class="tw-text-gray-800 tw-font-bold">
                          <span>{{i + 1}}</span>
                          <span class="tw-align-super tw-text-100 tw-mr-0.5">{{ (i + 1).toString() | dateSuffix: true }}</span>
                          <span i18n="@@checkup" class="tw-capitalize">Check-up</span>
                        </h3>
                        <img alt="doctor profile" src="{{doctorImage}}" class="tw-aspect-square tw-w-14 tw-bg-gray-200 tw-rounded-full tw-object-cover">
                        <span i18n="@@upload" class="tw-text-teal-600 tw-font-bold tw-mt-auto" (click)="startFollowUpOfId(followUp)">Upload</span>
                        <div class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-flex tw-justify-center tw-text-100 tw-font-bold tw-text-gray-50">
                          <span i18n="@@waitingForImage" class="tw-bg-orange-400 tw-rounded-b-1 tw-w-[103px] tw-h-5 tw-flex tw-justify-center tw-items-center tw-text-center">Waiting for image</span>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            }
          }
          <!--follow up active card -->
          <!--  report in process card-->
          <!--Waiting for image card-->
          <!--  Report ready Card -->
          @if (showReportReadyCard(followUp)) {
            <div *swiperSlide class="tw-h-full">
              <div class="tw-w-32 tw-bg-teal-100 tw-rounded-4 tw-h-full">
                <div class="tw-h-full tw-flex tw-flex-col tw-gap-5 tw-items-center tw-px-3 tw-py-5">
                  <h3 class="tw-font-bold">
                    {{followUp.completedOn.iso | date: 'dd MMM yy'}}
                  </h3>
                  <img alt="checkup-report-tick-icon" src="/assets/icons/checkup-report-tick-icon.svg" class="tw-w-10 tw-aspect-square">
                  <span i18n="@@viewReport" class="tw-text-teal-600 tw-font-bold tw-text-center tw-mt-auto" (click)="openReportOfId(followUp.followUpReportStatus?.FACE ?? followUp.followUpReportStatus?.HAIR)">View Report</span>
                </div>
              </div>
            </div>
          }
        }
        <!--  Lock Card -->
        @for (index of (userAllFollowUps?.length === 1 ? [1, 2] : [1]); track index) {
          @if (isRegimenExpired && index === 1) {
            <div *swiperSlide class="tw-h-full" (click)="handleRegimenExpiredClick()">
              <div class="tw-w-32 tw-bg-white tw-rounded-4 tw-shadow-z5 tw-h-full">
                <div class="tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-3 tw-pb-[11px] tw-pt-[19px]">
                  <h3 class="tw-text-gray-500 tw-text-300 tw-text-center tw-mb-4">Locked</h3>
                  <img alt="checkup-lock-icon" src="/assets/icons/checkup-lock-icon.svg" class="tw-w-9 tw-mb-4">
                  <div class="tw-bg-teal-600 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-rounded-2">
                    <p class="tw-w-full tw-text-white tw-font-bold tw-text-center tw-text-200 tw-capitalize tw-px-4 tw-py-[7px]" i18n="@@unlockNow">unlock now</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div *swiperSlide class="tw-h-full">
              <div class="tw-w-32 tw-bg-teal-100 tw-rounded-4 tw-shadow-z5 tw-h-full">
                <div class="tw-h-full tw-flex tw-flex-col tw-gap-3 tw-justify-center tw-items-center tw-px-3 tw-py-5">
                  <h3 i18n="@@nextCheckup" class="tw-text-gray-500 tw-text-center">Next Checkup</h3>
                  <img alt="checkup-lock-icon" src="/assets/icons/checkup-lock-icon.svg" class="tw-w-9 tw-mt-1">
                  <span class="tw-text-teal-600 tw-font-bold tw-invisible tw-mt-5"></span>
                </div>
              </div>
            </div>
          }
        }
      </swiper>
    </section>
    @if (regimenExpiryExperiment && regimenExpiryBannerData?.showBanner && !userAllReportsWithCheckUpNumber?.length) {
      <regimen-expiry-strip [userFirstName]="userFirstName" [page]="'checkup'" [regimenExpiryBannerData]="regimenExpiryBannerData" (bannerClick)="handleRegimenExpiryBannerClick()"></regimen-expiry-strip>
    }
    <!-- how to take checkup section-->
    @if (!userAllReportsWithCheckUpNumber?.length) {
      <section class="tw-p-6 tw-pb-8 tw-font-body">
        <h2 i18n="@@completeYourCheckupsInThreeEasySteps" class="tw-text-400 tw-pb-4 tw-mb-4 tw-border-b tw-border-b-gray-100">How to take check-up ?</h2>
        <div class="tw-text-400 tw-flex tw-flex-col tw-gap-2">
          <div class="tw-flex tw-gap-4">
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-flex-shrink-0">
              <img alt="checkup-step-1-icon" src="/assets/icons/checkup-step-1-icon.svg" class="tw-w-14 tw-aspect-square"/>
              <div class="tw-bg-teal-400 tw-h-8 tw-w-0.5"></div>
            </div>
            <div>
              <span i18n="@@stepOne" class="tw-text-gray-800 tw-text-200 ">STEP 1</span>
              <p i18n="@@answerFewQuestions" class="tw-text-400 tw-font-bold tw-tracking-normal">Answer a few questions</p>
            </div>
          </div>
          <div class="tw-flex tw-gap-4">
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-flex-shrink-0">
              <img alt="checkup-step-2-icon" src="/assets/icons/checkup-step-2-icon.svg" class="tw-w-14 tw-aspect-square"/>
              <div class="tw-bg-teal-400 tw-h-8 tw-w-0.5"></div>
            </div>
            <div>
              <span i18n="@@stepTwo" class="tw-text-gray-800 tw-text-200 ">STEP 2</span>
              <p i18n="@@shareYourPhotosWithYourDoctor" class="tw-text-400 tw-font-bold tw-tracking-normal">Share your photos with <br/> your doctor</p>
            </div>
          </div>
          <div class="tw-flex tw-gap-4">
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-flex-shrink-0">
              <img alt="checkup-step-3-icon" src="/assets/icons/checkup-step-3-icon.svg" class="tw-w-14 tw-aspect-square"/>
            </div>
            <div>
              <span i18n="@@stepThree" class="tw-text-gray-800 tw-text-200 ">STEP 3</span>
              <p i18n="@@getYourTreatmentProgressReport" class="tw-text-400 tw-font-bold tw-tracking-normal">Get your treatment <br/> progress report</p>
            </div>
          </div>
        </div>
      </section>
    }
    <!-- Better results -->
    @if (!userAllReportsWithCheckUpNumber?.length) {
      <section class="tw-bg-gray-100 tw-p-4 tw-font-body">
        <div class="tw-bg-gray-50 tw-rounded-2 tw-p-4 tw-py-5 tw-flex tw-justify-between">
          <div>
            <h1 i18n="@@ninetyPercentUsers" class="tw-text-teal-400 tw-text-700 tw-font-bold">95% users</h1>
            <p i18n="@@sawBetterResultsWithRegularCheckups" class="tw-text-300 tw-text-gray-400 tw-min-w-[50%]">Saw better results<br/>with regular checkups</p>
          </div>
          <div class="tw-flex-shrink-0" [ngClass]="(user.get('languagePreference') === 'te' || user.get('languagePreference') === 'ta') ? 'tw-min-w-[40%]' : ''">
            <img alt="checkup-user-result" class="tw-w-36 tw-h-auto" src="/assets/images/checkup-user-results.png">
          </div>
        </div>
      </section>
    }
    <!-- Regimen expiry strip -->
    @if (regimenExpiryExperiment && regimenExpiryBannerData?.showBanner && userAllReportsWithCheckUpNumber?.length) {
      <regimen-expiry-strip [userFirstName]="userFirstName" [regimenExpiryBannerData]="regimenExpiryBannerData" (bannerClick)="handleRegimenExpiryBannerClick()"></regimen-expiry-strip>
    }
    <!-- Checkup report list -->
    @if (userAllReportsWithCheckUpNumber?.length) {
      <section class="tw-p-4 tw-pt-5 tw-font-body">
        <h2 i18n="@@checkupReports" class="tw-text-400 tw-font-bold tw-font-body tw-mb-5">Checkup Reports</h2>
        <div class="tw-overflow-y-clip">
          @for (followUpReport of userAllReportsWithCheckUpNumber; track followUpReport; let i = $index) {
            <div class="tw-text-300 tw-flex tw-flex-col">
              <report-card class="tw-flex-1" [data]="followUpReport" [index]="i" [latestReportIds]="latestReportIds" [userAllReportsWithCheckUpNumber]="userAllReportsWithCheckUpNumber" [doctorImage]="doctorImage"></report-card>
            </div>
          }
        </div>
      </section>
    }
    <!-- In Process Pop up -->
    @if (isProcessPopUpOpen) {
      <div class="tw-fixed tw-inset-0 tw-z-10 tw-animate-fade_in backdrop-blur-sm" (click)="toggleProcessPopup()"></div>
      <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-z-20 tw-font-body tw-rounded-t-3xl tw-animate-slide_in_bottom">
        <div  class="tw-relative tw-p-5 tw-pt-14 tw-pb-10 tw-text-center">
          <h1 i18n="@@yourCheckupIsInProcessInProcess" class="tw-font-bold tw-text-700">Your checkup is <br/> in process.</h1>
          <p i18n="@@yourReportWillBeReadyWithinFortyEightHours" class="tw-text-[22px] tw-font-normal tw-mb-5 tw-text-gray-800 tw-font-body">your report will be ready <br/> within 48 hrs</p>
          <button i18n="@@okay" (click)="toggleProcessPopup()" class="tw-bg-teal-600 tw-text-white tw-text-300 tw-h-10 tw-mx-auto tw-text-center tw-w-full tw-font-bold tw-capitalize">okay</button>
          <div (click)="toggleProcessPopup()" class="tw-absolute tw-right-5 tw-top-5 tw-w-9">
            <img alt="isProcessPopUp CloseButton" src="/assets/icons/popupCloseButton.svg"/>
          </div>
        </div>
      </div>
    }
    <!-- Notify me Pop up -->
    @if (isNotifyMePopUpOpen) {
      <div class="tw-fixed tw-inset-0 tw-z-10 tw-animate-fade_in backdrop-blur-sm" (click)="toggleNotifyMePopup()"></div>
      <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-z-20 tw-font-body tw-rounded-t-3xl tw-animate-slide_in_bottom">
        <div  class="tw-relative tw-p-5 tw-pt-20 tw-pb-10 tw-text-center">
          <h1 i18n="@@notifyMePopupThankYou" class="tw-font-bold tw-text-700">Thank you.</h1>
          <p i18n="@@weWillNotifyYouOnceYourCheckupIsNear" class="tw-text-[22px] tw-font-normal tw-mb-5 tw-text-gray-800 tw-font-body">We will notify you once <br/> your checkup is near</p>
          <button i18n="@@okay" (click)="toggleNotifyMePopup()" class="tw-bg-teal-600 tw-text-white tw-text-300 tw-h-10 tw-mx-auto tw-text-center tw-w-full tw-font-bold tw-capitalize">okay</button>
          <div (click)="toggleNotifyMePopup()" class="tw-absolute tw-right-5 tw-top-5 tw-w-9">
            <img alt="isNotifyMePopUp CloseButton" src="/assets/icons/popupCloseButton.svg"/>
          </div>
        </div>
      </div>
    }
  }
}
